// modifer: styles/jss/nextjs-material-kit-pro/pages/sectionsSections/featuresStyle
import { section, container, title, description } from 'styles/jss/original/base';

const styles = {
  section,
  container,
  title: {
    ...title,
    textAlign: 'center',
    padding: '20px 0'
  },
  description: {
    ...description,
    textAlign: 'center',
    whiteSpace: 'pre-wrap',
    '@media (max-width: 768px)': {
      textAlign: 'left',
      whiteSpace: 'normal'
    }
  }
};

export default styles;
